export const DELETE_TERRITORY_IN_USE_BY_OVERLAY_ERROR =
  'The Rule is in use by an overlay. Please remove from the overlay and try again.';
export const FILE_UPLOAD_MISSING_INPUT = 'likely missing from the input file';
